<template>
  <div>
    <div class="thank-you-container">
      <h1>Thank You</h1>
      <p>
        Thank you. Your support helps spread Torah throughout the world, impacting and
        elevating thousands of lives.
      </p>

      <p>
        Your partnership in our work is very meaningful. Together, we will continue to
        expand our audiences, inspire more people and ultimately touch more lives.
      </p>

      <p>
        If you have not already, we encourage you to check out our full line of programs
        and online platforms.
      </p>
      <div class="header__center">
        <a href="https://outorah.org/" class="header__logo"
          ><img
            src="https://res.cloudinary.com/orthodox-union/image/upload/c_thumb,h_30,g_face/v1572779009/Torah/ou_logo_simple_blue.png"
            alt="OU Torah Logo"
            target="_blank"
        /></a>
        <a href="https://alldaf.org/" class="header__logo"
          ><img
            src="https://res.cloudinary.com/orthodox-union/image/upload/f_auto,q_auto/v1613988233/Torah/allparsha/All_Daf_Logo.png"
            alt="All Daf Logo"
            target="_blank"
        /></a>
        <a href="https://allmishnah.org/" class="header__logo"
          ><img
            src="https://res.cloudinary.com/orthodox-union/image/upload/v1638279618/Torah/logos/AMx30.png"
            alt="allmishnah Logo"
            target="_blank"
        /></a>
        <a href="https://allparsha.org/"
          ><img
            src="https://res.cloudinary.com/orthodox-union/image/upload/f_auto,q_auto/v1613988233/Torah/allparsha/Logo_All_Parsha.png"
            alt="All Parsha Logo"
        /></a>
      </div>

    </div>
  </div>
</template>

<style scoped>
.thank-you-container {
  padding: 20px;
  min-height: 300px;
  margin: 0 auto;
  background: #dff9e1;
  color: black;
  line-height: 1.4;
  font-weight: 400;
  text-align: center;
}

.ty__note {
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;
}
.dd__wrap {
  max-width: 550px;
  margin: 0 auto 20px;
}
.header__center {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px auto;
}
.header__logo {
  padding: 0 12px;
}
</style>
